import React from 'react';
import logo from './logo.svg';
import './index.css';

const Logo = () => (
  <div className="logo">
    <img src={logo} alt="Money Tracker" />
  </div>
);

export default Logo;
